import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { networkGradingsQueryKeys } from "./queryKeys"

export function useNetworkYearGrading(year, queryParameters, config = {}) {
    const url = "network_gradings/"

    const parameters = useExtendWithSubnetworks({ ...queryParameters, year }, API_MODULE_ROADWAY)
    const key = networkGradingsQueryKeys.list(parameters)

    return useRoadQuery(
        url,
        key,
        parameters,
        config,
    )
}